<template>
  <div class="pt-3">{{ $t('soon') }}</div>
</template>

<script>
export default {
  name: "VisitConfirmFunnelTab"
}
</script>

<style scoped>

</style>